import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import ImportServices from '@root/modules/Sellers/Import/services/import';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import ButtonImport from '@root/modules/Warehouse/Inbound/components/Button';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import CheckPoint from '@root/modules/Warehouse/Inquiry/components/shipping/CheckPoint';
import ShipmentMethod from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethod';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import { Card, message, RadioChangeEvent, Typography } from 'antd';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ProductContext } from '../../provider/ProductProvider';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import AutoCompleteImport from '../components/AutoComplete';
import AddComment from './AddComment';

const ImportStock = () => {
  const [t] = useTranslate();
  const [value, setValue] = useState('');
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [nameDetail, setNameDetail] = useState([] as any);
  const [detailImportStock, setDetailImportStock] = useState([] as any);
  const [addressDetail, setAddressDetail] = useState([] as any);
  const [product, setProduct] = useState([] as any);
  const { Text } = Typography;
  const debounc = useDebounce(value, 1000);
  const history = useHistory();
  const Breadcrumb = [
    {
      tittle: '입고 관리',
      url: ''
    },
    {
      tittle: '입고 신청',
      url: ''
    }
  ];

  const onSearch = async (searchText: string) => {
    const listId = await ImportServices.searchQuotation(searchText);
    if (listId) {
      setOptions(
        listId.length == 0
          ? []
          : listId.data.map((value: any) => {
              return { value: value.id };
            })
      );
    }
  };

  useEffect(() => {
    onSearch(value);
  }, [debounc]);

  const onSelect = async (data: string) => {
    const quoteDetail = await InquiryServices.getListQuoteDetail(data);
    setProduct(quoteDetail.data);
    setCheckpoint(quoteDetail.data.checkPoint);
    setMethod(quoteDetail.data.shipmentMethod);
    setDetail(quoteDetail.data.shipmentDetail);
    setEtd(quoteDetail.data.shippingPlanEtd);
    setEta(quoteDetail.data.shippingPlanEta);
    setShowAdd(true);
    const list: any[] = [];
    const arrData: any[] = quoteDetail.data.products;
    arrData.forEach((item: any, index: number) => {
      list.push({
        productName: item.productName,
        width: item.width,
        height: item.height,
        length: item.length,
        demensionUnit: item.demensionUnit,
        weight: item.weight,
        weightUnit: item.weightUnit,
        estimateQuantity: item.estimateQuantity,
        averageMonthSale: item.averageMonthSale,
        sku: item.sku,
        eanUpc: item.eanUpc,
        asin: item.asin,
        packedMethod: item.packedMethod,
        storageMethod: item.storageMethod,
        dangerousGoods: item.dangerousGoods,
        lotProduct: item.lotProduct,
        image: item?.image?.url
      });
    });
    setDetailImportStock(list);
    setNameDetail(quoteDetail.data.seller);
    setAddressDetail(quoteDetail.data.warehouse);
  };
  const onChange = (data: string) => {
    setValue(data);
    if (!data) {
      setShowAdd(false);
      setDetailImportStock([]);
      setAddressDetail([]);
      setCheckpoint('');
      setMethod('');
      setDetail('');
      setEtd('');
      setEta('');
      setProduct([]);
    }
  };

  /*--------------ad comt--------------*/
  const [selectedFile, setSelectedFile] = useState([] as any);
  const [fileIdArrNew, setfileIdArrNew] = useState([] as any);
  const [img, setImg] = useState([] as any);
  const [cmt, setCmt] = useState('');
  const [showAdd, setShowAdd] = useState(false);
  const [listImg, setListImg] = useContext<any>(ProductContext);
  const valueMethod = product?.shipmentMethod;
  const valueDetail = product?.shipmentDetail;
  const valuePoint = product?.checkPoint;
  const valueEtd = product?.shippingPlanEtd;
  const valueEta = product?.shippingPlanEta;

  const [method, setMethod] = useState('');
  const [checkpoint, setCheckpoint] = useState('');
  const [detail, setDetail] = useState('');
  const [etd, setEtd] = useState('');
  const [eta, setEta] = useState('');

  function handleChangePoint(event: any) {
    setCheckpoint(event.target.value);
  }
  function handleChangeDetail(event: any) {
    setDetail(event.target.value);
  }
  const onChangeRadio = (e: RadioChangeEvent) => {
    setMethod(e.target.value);
  };

  useEffect(() => {}, [
    valueMethod,
    valuePoint,
    valueDetail,
    valueEta,
    valueEtd
  ]);

  useEffect(() => {}, [cmt]);

  useEffect(() => {
    setEta(eta);
  }, [eta]);

  useEffect(() => {
    setEtd(etd);
  }, [etd]);

  const handleUploadFiles = (files: any) => {
    const uploaded = [...selectedFile];

    files.some((file: any) => {
      if (uploaded.findIndex((f) => f.name === file.name) === -1) {
        uploaded.push(file);
      }
      setSelectedFile(uploaded);
    });
  };

  const handleFileEvent = (e: any) => {
    const chosenFiles = Array.prototype.slice.call(e);
    handleUploadFiles(chosenFiles);
  };

  const handleAddComment = async (values: any) => {
    try {
      if (!(img.length > 0) || cmt === '') {
        message.error('Files or comment must not be empty!');
      } else {
        const formData = new FormData();
        for (let i = 0; i < img.length; i++) {
          formData.append('files', img[i].originFileObj);
        }
        const uploadData = await ImportServices.upLoad(formData);
        setListImg(uploadData.data);
        uploadData.data.forEach((element: any) => {
          fileIdArrNew.push(element.id);
        });
        const body = {
          sellerComment: cmt,
          quotationId: value,
          fileIds: fileIdArrNew,
          shipmentMethod: method,
          shipmentDetail: detail,
          checkPoint: checkpoint,
          shippingPlanEtd: moment(etd).format('YYYY-MM-DD'),
          shippingPlanEta: moment(eta).format('YYYY-MM-DD')
        };
        const createCmt = await ImportServices.createCommentImport(body);
        if (createCmt.massage === 'success') {
          message.success('Add comment success!');
          history.push('/admin/seller/import');
        }
      }
    } catch (error) {
      message.error('Add comment fail!');
    }
  };

  const getImg = (e: any) => {
    setImg(e);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <Card
        bordered={false}
        className="admin-card btnImport"
        style={{
          minHeight: '80vh',
          background: 'none'
        }}
      >
        <div className="appStock">
          <div className="stockTop">
            <div className="searchStock">
              <span>견적번호</span>
              <div className="searchNumber">
                <AutoCompleteImport
                  value={value}
                  onChange={onChange}
                  options={options}
                  onSelect={onSelect}
                  // onSearch={onSearch}
                />
              </div>
            </div>
            <div className="searchStock marTop">
              <div className="searchStock item center">
                <span>물류센터</span>
                <Text keyboard disabled>
                  {addressDetail.name}
                </Text>
              </div>
              <div className="searchStock item address">
                <span>물류센터 주소</span>
                <Text keyboard disabled>
                  {addressDetail.googleMapAddress}
                </Text>
              </div>
            </div>
          </div>
          {nameDetail ? (
            <div className="showName">
              <span> {`${nameDetail.firstName} ${nameDetail.lastName}`} </span>
              <span>{nameDetail.id} </span>
            </div>
          ) : (
            ''
          )}

          <div className="wrapInfStock">
            {detailImportStock.map((item: any) => {
              return (
                <DetailsPro
                  productName={item.productName}
                  width={item.width}
                  height={item.height}
                  length={item.length}
                  demensionUnit={item.demensionUnit}
                  weight={item.weight}
                  weightUnit={item.weightUnit}
                  estimateQuantity={item.estimateQuantity}
                  averageMonthSale={item.averageMonthSale}
                  sku={item.sku}
                  eanUpc={item.eanUpc}
                  asin={item.asin}
                  packedMethod={item.packedMethod}
                  storageMethod={item.storageMethod}
                  dangerousGoods={item.dangerousGoods}
                  lotProduct={item.lotProduct}
                  img={item.image}
                />
              );
            })}
            <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
              <ShipmentMethod
                statusBox={
                  Object.keys(detailImportStock).length > 0 ? true : false
                }
                shipmentMethod={method}
                handleChange={handleChangeDetail}
                onChangeRadio={onChangeRadio}
                detail={detail}
              />
              <ShippingPlant
                flag={Object.keys(detailImportStock).length > 0 ? true : false}
                flagCheck={
                  Object.keys(detailImportStock).length === 0 ? true : false
                }
                shippingPlanEtd={product?.shippingPlanEtd}
                shippingPlanEta={product?.shippingPlanEta}
                onChange={(date1: any, date2: any) => {
                  setEta(date1);
                  setEtd(date2);
                }}
              />
              <CheckPoint
                statusBox={
                  Object.keys(detailImportStock).length > 0 ? true : false
                }
                checkPoint={checkpoint}
                handleChange={handleChangePoint}
              />
            </div>
            <div>
              {showAdd && (
                <AddComment
                  quotationId={value}
                  handleFileEvent={handleFileEvent}
                  handleAddComment={handleAddComment}
                  setCmt={setCmt}
                  cmt={cmt}
                  setImg={getImg}
                  img={img}
                />
              )}
            </div>

            <div className="btnApp">
              <ButtonImport
                handleClick={handleAddComment}
                typeButton=""
                label="입고 신청"
                disable={
                  Object.keys(detailImportStock).length > 0 ? false : true
                }
              />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default ImportStock;
